import { render, staticRenderFns } from "./BlogPosts.vue?vue&type=template&id=0393ae8e&scoped=true&"
import script from "./BlogPosts.vue?vue&type=script&lang=ts&"
export * from "./BlogPosts.vue?vue&type=script&lang=ts&"
import style0 from "./BlogPosts.vue?vue&type=style&index=0&id=0393ae8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0393ae8e",
  null
  
)

export default component.exports